import React from 'react'
import {findDOMNode} from 'react-dom'

import NavigationMenu_ProjectsLocalSettings from "../../local-settings"
import NavigationMenu_TopHeader from "../../components/top-header/top-header"
import {MenuComponentProps} from "../const"
import VScroll from "../../../../core/gd-components/scrolling/custom-v-scroll/v-scroll"
import Workspace from "../../../../core/model2/space/workspaces/workspace"
import MenuSearch_Results from "../../../search/search-results/menu-search-results"
import MenuTopHeader_SearchActive from "../../components/top-header/search/search"
import {MenuSpaceSearch} from "../../components/search/menu-space-search"
import MenuTopHeader_SearchButton from "../../components/top-header/search/search-button"
import MainMenu_WorkspaceContent from "./content"
import {UIType} from "../../../ui/@const";
import NavigationMenu_WorkspaceDropdownSettings from "./settings/dropdown/workspace-dropdown";


// const debug = "MainMenu_Workspace"
const debug = false

export default class MainMenu_Workspace extends React.Component<MenuComponentProps> {

    private animationDelay      : any
    private animShow            : boolean = false
    public spaceSearch          : MenuSpaceSearch
    public localSettings        : NavigationMenu_ProjectsLocalSettings
    private workspace           : Workspace

    constructor(props:MenuComponentProps) {
        super(props)

        debug && console.log(debug, 'constructor', props.section)

        this.workspace      = props.section.space as Workspace
        this.localSettings  = new NavigationMenu_ProjectsLocalSettings(this.workspace.id)

        this.spaceSearch    = new MenuSpaceSearch(this.workspace, this.reRender)
    }

    componentDidMount() {
        // gd.bus.subscribe(BUS_TREE_CHANGE, this, this.sessionDataChanged)
        // gd.bus.subscribe(SESSION_COMPANY_SETTINGS_CHANGED, this, this.sessionDataChanged)
        // gd.bus.subscribe(BUS_USER_CHANGE, this, this.sessionDataChanged)
        //
        // // need it on this level as we separate stars and all projects
        // gd.bus.subscribe(SESSION_STARRED_CHANGED, this, this.sessionDataChanged)
        // gd.bus.subscribe(SESSION_PROJECT_CHANGE, this, this.sessionProjectChanged)
        // gd.bus.subscribe(SESSION_PROJECT_USERS_CHANGED, this, this.sessionProjectUsersChanged)

        this.animationDelay = _.delay(()=>{
            this.animShow = true
            const dom = findDOMNode(this)
            gd.utils.Dom.addClass(dom, 'anim-show')
        }, 50)
    }

    componentWillUnmount() {
        clearTimeout(this.animationDelay)
        gd.bus.unsubscribe(this)
    }

    // sessionDataChanged = () => {
    //     this.forceUpdate()
    // }

    // sessionProjectChanged = (projectId: ID) => {
    //     if (this.workspace.id === gd.session.projects.get(projectId)?.space.id) {
    //         this.forceUpdate()
    //     }
    // }
    //
    // // is required to update on user is added/removed to/from project
    // sessionProjectUsersChanged = () => {
    //     this.forceUpdate()
    // }

    async expandParentsForProject(projectId:ID) {
        return new Promise((resolve, reject) => {
            const parentProjectsIds = gd.session.projects.getAllParents(projectId).map((p:any)=>p.id)
            this.localSettings.expandedProjects = _.union(this.localSettings.expandedProjects, parentProjectsIds)
            this.localSettings.save()

            this.forceUpdate(()=>{
                resolve(true)
            })
        })
    }

    reRender = ()=> {
        this.forceUpdate()
    }

    render() {

        // const rootTags = this.workspace.rootTags

        debug && console.log(debug, 'render()', this.workspace)

        const classes = Classes('main-menu-container ui5-menu menu-projects', {
            'animation'     : gd.layout.shouldAnimateMenu && !this.props.noAnimation,
            'anim-show'     : this.animShow
        })

        const rightButtonsClasses = Classes("flex-row-right-center", {
            "w-100-percent": this.spaceSearch.isActive
        })

        const isSearchEnabled   = this.spaceSearch.searchValue.length !== 0
        // const properties = this.workspace.project.properties as ProjectWorkspaceProperties
        // const showResources = !properties.hideResourcesIfEmpty || this.workspace.resources.length > 0
        // const showViews     = properties.showViewsGroup

        return (
            <div className={classes}>

                {!this.spaceSearch.isActive && gd.ui.type !== UIType.GOODDAY_MODERN &&
                    <NavigationMenu_TopHeader space={this.workspace}>
                        <div className={rightButtonsClasses}>
                            <MenuTopHeader_SearchButton
                                className   = "m-r-15"
                                spaceSearch = {this.spaceSearch}
                            />
                        </div>
                    </NavigationMenu_TopHeader>
                }

                {gd.ui.type === UIType.GOODDAY_MODERN && (
                    <NavigationMenu_WorkspaceDropdownSettings spaceSearch={this.spaceSearch} workspace={this.workspace} />
                )}

                {this.spaceSearch.isActive && gd.ui.type !== UIType.GOODDAY_MODERN &&
                    <div className="top-header flex-row-between-center">
                        <MenuTopHeader_SearchActive spaceSearch={this.spaceSearch}/>
                    </div>
                }


                <VScroll ref={this.props.refScroll} className="main-menu-scroll" mutationObserverEnabled={true}>

                    {isSearchEnabled &&
                        <MenuSearch_Results
                            space           = {this.workspace}
                            searchResult    = {this.spaceSearch.searchResults}
                        />
                    }

                    {!isSearchEnabled && (
                        <MainMenu_WorkspaceContent {...this.props} />
                    )}
                </VScroll>
            </div>
        )
    }
}
